import React, {useState, useEffect} from "react";

export default function SparePartsIndexedDB() {
  // 1
  const indexedDB =
    window.indexedDB ||
    window.mozIndexedDB ||
    window.webkitIndexedDB ||
    window.msIndexedDB ||
    window.shimIndexedDB;

  if (!indexedDB) {
    console.log("IndexedDB could not be found in this browser.");
  }

  // 2
  const request = indexedDB.open("CarsDatabase", 1);

  request.onerror = function (event) {
    console.error("An error occurred with IndexedDB");
    console.error(event);
  };

  request.onupgradeneeded = function () {
    //1
    const db = request.result;
  
    //2
    const store = db.createObjectStore("cars", { keyPath: "id" });
  
    //3
    store.createIndex("cars_colour", ["colour"], { unique: false });
  
    // 4
    store.createIndex("colour_and_make", ["colour", "make"], {
      unique: false,
    }); 
  };

  request.onsuccess = function () {
    console.log("Database opened successfully");
  
    const db = request.result;
  
    // 1
    const transaction = db.transaction("cars", "readwrite");
  
    //2
    const store = transaction.objectStore("cars");
    const colourIndex = store.index("cars_colour");
    const makeModelIndex = store.index("colour_and_make");
  
    //3
    store.put({ id: 1, colour: "Red", make: "Toyota" });
    store.put({ id: 2, colour: "Red", make: "Kia" });
    store.put({ id: 3, colour: "Blue", make: "Honda" });
    store.put({ id: 4, colour: "Silver", make: "Subaru" });
  
    //4
    const idQuery = store.get(4);
    const colourQuery = colourIndex.getAll(["Red"]);
    const colourMakeQuery = makeModelIndex.get(["Blue", "Honda"]);
  
    // 5
    idQuery.onsuccess = function () {
      console.log('idQuery', idQuery.result);
    };
    colourQuery.onsuccess = function () {
      console.log('colourQuery', colourQuery.result);
    };
    colourMakeQuery.onsuccess = function () {
      console.log('colourMakeQuery', colourMakeQuery.result);
    };
  
    // 6
    transaction.oncomplete = function () {
      db.close();
    };
  };

  const [data, setData] = useState([]);
  const [dbdata, setDbData] = useState([]);


  const fetchSpareParts = async () => {
    try {
      const response = await fetch(
        //`/api/v1/logistics/orders/item/status/watchToTest/9999`,
        //'/api/v1/WatchHunter/Watches/Search',
        '/api/search/filter?category=Aufzugwellen%2CSchrauben%2CZugfedern%2CZifferbl%C3%A4tter%2CZeiger%2CRotoren%2CSonstige%20Werkteile%2CE-Bl%C3%B6cke%2CGl%C3%A4ser%2CDichtungen%2CKronen%2CDr%C3%BCcker%2CGeh%C3%A4use%20Schrauben%2CFederstege%2CStifte%2CBandh%C3%BClsen%2CBand%20Schrauben%2CVerbrauchsmaterial%2CWerkzeug%2CWerkzeug%2CBatterien%2CTest%2CBedarfsartikel%2CArmb%C3%A4nder%2CSchlie%C3%9Fen&maxResults=100000',
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setData(payload);
      console.log("Payload : ", payload);
      storeApiResponseToIndexedDb(payload)
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const storeApiResponseToIndexedDb=(apiData) => {
    // 2
  const request = indexedDB.open("SparePartsDataBase", 1);

  request.onerror = function (event) {
    console.error("An error occurred with IndexedDB");
    console.error(event);
  };

  request.onupgradeneeded = function () {
    //1
    const db = request.result;
  
    //2
    const store = db.createObjectStore("SpareParts", { keyPath: "id" });
  
    //3
   // store.createIndex("cars_colour", ["colour"], { unique: false });
  
    // 4
    //store.createIndex("colour_and_make", ["colour", "make"], {
      //unique: false,
    //}); 
  };



  request.onsuccess = function () {
    console.log("sparepart Database opened successfully");
  
    const db = request.result;
  
    // 1
    const transaction = db.transaction("SpareParts", "readwrite");
  
    //2
    const store = transaction.objectStore("SpareParts");
    //const colourIndex = store.index("cars_colour");
    //const makeModelIndex = store.index("colour_and_make");
  
    //3
    store.put({id: 1,apiData});
   // store.put({ id: 2, colour: "Red", make: "Kia" });
    //store.put({ id: 3, colour: "Blue", make: "Honda" });
    //store.put({ id: 4, colour: "Silver", make: "Subaru" });
  
    //4
    const idQuery = store.get(1);
    //const colourQuery = colourIndex.getAll(["Red"]);
    //const colourMakeQuery = makeModelIndex.get(["Blue", "Honda"]);
    
    // 5
    idQuery.onsuccess = function () {
      console.log('idQuery', idQuery.result);
      setDbData(idQuery.result)
    };

  
    // 6
    transaction.oncomplete = function () {
      db.close();
    };
  };
  }
  useEffect(() => {
    fetchSpareParts()
  }, []);
  
  return (
    <div>
      <button>write the stored data</button>
    <p>
        { JSON.stringify(dbdata)}
    </p>
    </div>
  );
}
